import React from 'react';

export const NoMath = () => {
  return <div>NoMath</div>;
};
